const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		preventSortOfField: {},
		buttonContext: 'address',
		renderEmptyBeforReady: false,
		inline: true,
		maxNrOfExportElements: 500000
	},

	methods: {
		export: function(){
			var self = this;
			var nrOfMatchingElements = ((((this.resourceData || {}).nrOfElements || {}).data || {}).attributes || {}).nrOfMatchingElements || 0;
			if(nrOfMatchingElements > self.config.maxNrOfExportElements){
				return self.performDecision(
					'confirm',
					{
						component:  self,
						title:      storage.__('hint.artForm.address.export.limit.title'),
						message:    storage.__('hint.artForm.address.export.limit.message', { max: self.config.maxNrOfExportElements, nrOfMatchingElements: nrOfMatchingElements })
					}
				).then(function(context){
					if(context.decision.type === 'yes'){
						self.chooseExportType();
					}
				});
			}

			self.chooseExportType();
		},

		chooseExportType: function(){
			var self = this;
			return self.performDecision(
				'chooseExportType',
				{
					component:  self,
					title:      storage.__('addresses.export.chooseType.title'),
					message:    storage.__('addresses.export.chooseType.message')
				}
			).then(function(context){
				if(
					context.decision.type === 'export'
					&&
					(
						context.decision.mode === 'artFormAddresses' ||
						context.decision.mode === 'artFormLabels' ||
						context.decision.mode === 'artFormKubeos'
					)
				){
					self.startExport(context.decision.mode);
				}
			});
		},

		startExport: function(mode){
			var resourceFilters 	= utils.copy(this.getResourceFilters(storage, undefined, 'refreshResources')) || {};
			resourceFilters.offset 	= 0;
			resourceFilters.limit 	= this.config.maxNrOfExportElements;
			var filename = 'art_form_addresses_' + utils.moment().format('YYYY-MM-DD_hh-mm-ss') + '.xlsx';
			window.open('/LTR/~/exports/art_form/addresses/' + mode + '/' + filename + '?body=' + Buffer.from(JSON.stringify({
				resourceFilters: resourceFilters
			})).toString('base64'), '_blank');
		},

		showEdit: function(addressID, addressData){
			return getComponent('artFormController').showEdit('address', addressID, addressData);
		},

		addEntity: function(entity){
			// add entity to dom if necessary
			if(this.config.isReady && this.model.$table){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }))
			}
		},

		delete: function(){
			var self = this;
			var nrOfMatchingElements = (((self.resourceData.nrOfElements || {}).data || {}).attributes || {}).nrOfMatchingElements || 0;

			if(nrOfMatchingElements > 0){
				self.performDecision(
					'confirm',
					{
						component:  self,
						title:      storage.__('hint.delete.really.artFormAddresses.title'),
						message:    storage.__('hint.delete.really.artFormAddresses.message', { nrOfMatchingElements: nrOfMatchingElements }),
					}
				).then(function(context){
					if(context.decision.type === 'yes'){
						self.config.forceResourceFilterPreparation = true;
						var filters = (self.getResourceFilters(storage) || {}).filters || {};
						self.config.forceResourceFilterPreparation = false;

						return self.performAction(
							self.prepareAction('deleteFilteredAddresses', undefined, undefined, {
								source: {
									submit: {
										resourceFilters: {
											filters: filters
										}
									}
								}
							})
						).then(function(){
							self.refreshData();
						});
					}
				});
			} else {
				self.performAction(self.prepareAction('message', undefined, {
					messageDisplay: {
						message: 'error:delete.artform_addresses.noMatchingElementsFound'
					}
				}));
			}
		},

		setProcessed: function(){
			var self = this;
			var nrOfMatchingElements = (((self.resourceData.nrOfElements || {}).data || {}).attributes || {}).nrOfMatchingElements || 0;

			if(nrOfMatchingElements > 0){
				self.performDecision(
					'confirm',
					{
						component:  self,
						title:      storage.__('hint.setProcessed.really.artFormAddresses.title'),
						message:    storage.__('hint.setProcessed.really.artFormAddresses.message', { nrOfMatchingElements: nrOfMatchingElements }),
					}
				).then(function(context){
					if(context.decision.type === 'yes'){
						self.config.forceResourceFilterPreparation = true;
						var filters = (self.getResourceFilters(storage) || {}).filters || {};
						self.config.forceResourceFilterPreparation = false;

						return self.performAction(
							self.prepareAction('setFilteredAddressesProcessed', undefined, undefined, {
								source: {
									submit: {
										resourceFilters: {
											filters: filters
										}
									}
								}
							})
						).then(function(){
							self.refreshData();
						});
					}
				});
			} else {
				self.performAction(self.prepareAction('message', undefined, {
					messageDisplay: {
						message: 'error:setProcessed.artform_addresses.noMatchingElementsFound'
					}
				}));
			}
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_artForm_entity_controller', function(controller){
					self.model.controller = controller
				});
			}

			self.model.$table = $element.find('table');
		}
	},

	handlers: [{
		name: 'recordControllerResourcesModified',
		handle: function(callerComponent) {
			if(this.config.isReady){
				this.refreshData();
			}
		}
	}]
}